var _ellipse, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 58,
    rx: 14,
    ry: 4,
    fill: "black",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 4C20.954 4 12 12.954 12 24C12 39 30 55 31.3 56.1C31.7 56.4 32.3 56.4 32.7 56.1C34 55 52 39 52 24C52 12.954 43.046 4 32 4Z",
    fill: "#D81F51"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 12,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21L26.5 17H37.5L39 21V23C39 24.1 38.1 25 37 25C35.9 25 35 24.1 35 23C35 24.1 34.1 25 33 25C31.9 25 31 24.1 31 23C31 24.1 30.1 25 29 25C27.9 25 27 24.1 27 23C27 24.1 26.1 25 25 25C23.9 25 23 24.1 23 23V21H25ZM25 27C26 27 26.8 26.4 27 25.6C27.2 26.4 28 27 29 27C30 27 30.8 26.4 31 25.6C31.2 26.4 32 27 33 27C34 27 34.8 26.4 35 25.6C35.2 26.4 36 27 37 27C38.1 27 39 26.1 39 25V31H25V27Z",
    fill: "#D81F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.eab7ec16f5f04f1793c419ee4f0baca6.svg";
export { ForwardRef as ReactComponent };